import React, { createContext, useMemo, useState } from 'react';

type ContextType = {
  isShareNotificationVisible: boolean;
  setShareNotificationVisible: (_bool: boolean) => void;
};
const defaultContext: ContextType = {
  isShareNotificationVisible: false,
  setShareNotificationVisible() {}
};

const ShareContext = createContext<ContextType>(defaultContext);

export function ShareContextProvider({ children }: React.PropsWithChildren) {
  const [isShareNotificationVisible, setShareNotificationVisible] =
    useState<boolean>(false);

  const value = useMemo<ContextType>(
    (): ContextType => ({
      isShareNotificationVisible,
      setShareNotificationVisible
    }),
    [isShareNotificationVisible, setShareNotificationVisible]
  );

  return (
    <ShareContext.Provider value={value}>{children}</ShareContext.Provider>
  );
}

export default ShareContext;
